import { defineComponent as _defineComponent } from 'vue'
import { defineComponent, watch, ref, toRef, PropType, computed } from 'vue'
import { useRouter } from 'vue-router/composables'

type Remind = {
  id: Number,
  richId: Number,
  version: string,
  title: string,
  changeDesc: string,
  addTime: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  /**
   * 弹窗是否展示
   */
  show: {
    type: Boolean,
    default: () => {
      return true
    },
  },
  /* 
  * 协议变更列表
  */
  list: {
    type: Array as PropType<Remind[]>,
    required: true,
    default: () => ([])
  },
},
  emits: ['cancle', 'confirm'],
  setup(__props, { emit }) {

const props = __props;

const router = useRouter()



/**
 * 跳转到协议详情
 */
const toRule = (item) => {
  router.push({ path: '/documentInfo', query: { id: item.richId, title: item.title } })
}
/**
 * 拒绝签署协议
 */
const cancle = () => {
  emit('cancle')
}
/**
 * 确定签署协议
 */
const confirm = () => {
  emit('confirm')
}


return { __sfc: true,router, emit, props, toRule, cancle, confirm }
}

})